import { memoize } from "lodash/fp";
import { get } from "storefront/GrailedAPI/request";

export type Response = {
  data: Array<string>;
};

/**
 * @name GrailedAPI.v1.Internal.Users.getBanReasons
 */
const getBanReasons: () => Promise<Response> = () =>
  get(`/api/internal/users/ban_reasons`);

export default memoize(getBanReasons);
